import { buildBaziReport, buildBaziReportStandard } from '../core/bazi_engine.js';

export async function calculateBaziAsync(options) {
  return buildBaziReport(options);
}

export async function calculateBaziStandardAsync(input) {
  return buildBaziReportStandard(input);
}
